/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconIroning2 = createReactComponent("ironing-2", "IconIroning2", [
  ["path", { d: "M10 15h.01", key: "svg-0" }],
  [
    "path",
    {
      d: "M9 6h7.459a3 3 0 0 1 2.959 2.507l.577 3.464l.81 4.865a1 1 0 0 1 -.985 1.164h-16.82a7 7 0 0 1 7 -7h9.8",
      key: "svg-1"
    }
  ],
  ["path", { d: "M14 15h.01", key: "svg-2" }]
]);

export { IconIroning2 as default };
//# sourceMappingURL=IconIroning2.js.map
